// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"42699bee","332":"7f101425","650":"b58ffce1","657":"25088b64","723":"ec288f85","878":"662d82b7","909":"528efadd"}[chunkId] + ".chunk.js";
};